// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".img-placeholder i[data-v-4295d220] {\n  color: #2f6eae;\n  font-size: 50px;\n}\n.navbar .nav .nav-user .avatar-container img[data-v-4295d220] {\n  width: 52px;\n  height: 52px;\n  background-color: #d9d9d9;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
